module.exports = __webpack_public_path__ + "static/img/reports.96db670.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu-icons/reports.svg
// module id = nIKQ
// module chunks = 1